export default {"src":"/account/preferences/_next/static/media/Folder.168b7ff1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};